// Spinner HTML generated from https://loading.io/spinner/blocks/-rectangle-square-rotate-cycle-adobe
import React, { Fragment as div } from 'react';

import './LoadingSpinner.scss';

export default function LoadingSpinner() {
  return (
    <div className='loadingio-spinner-blocks-64wkp1cvdlc screen-centre'>
      <div className='ldio-911o0wgbgbn'>
        <div style={{ left: '38px', top: '38px', animationDelay: '0s' }} />
        <div style={{ left: '80px', top: '38px', animationDelay: '0.125s' }} />
        <div style={{ left: '122px', top: '38px', animationDelay: '0.25s' }} />
        <div style={{ left: '38px', top: '80px', animationDelay: '0.875s' }} />
        <div style={{ left: '122px', top: '80px', animationDelay: '0.375s' }} />
        <div style={{ left: '38px', top: '122px', animationDelay: '0.75s' }} />
        <div style={{ left: '80px', top: '122px', animationDelay: '0.625s' }} />
        <div style={{ left: '122px', top: '122px', animationDelay: '0.5s' }} />
      </div>
    </div>
  );
}
